import { useNode } from '@craftjs/core';
import { ImageIcon } from 'lucide-react';
import { cn } from '../../../../lib/utils';

interface ImageBlockProps {
  src: string;
  alt: string;
  caption: string;
  objectFit: 'cover' | 'contain' | 'fill';
  borderRadius: number;
  mediaId?: string;
}

export function ImageBlock({ src, alt, caption, objectFit, borderRadius, mediaId: _mediaId }: ImageBlockProps) {
  void _mediaId; // stored for cleanup on block delete
  const {
    connectors: { connect, drag },
    selected,
  } = useNode((state) => ({
    selected: state.events.selected,
  }));

  return (
    <figure
      ref={(ref) => {
        if (ref) connect(drag(ref));
      }}
      className={cn(
        'block p-1 rounded transition-all',
        selected && 'ring-2 ring-primary ring-offset-2'
      )}
    >
      {src ? (
        <img
          src={src}
          alt={alt}
          className="w-full h-auto block"
          style={{ objectFit, borderRadius: `${borderRadius}px` }}
        />
      ) : (
        <div
          className="w-full h-48 flex flex-col items-center justify-center bg-muted rounded text-muted-foreground gap-2"
          style={{ borderRadius: `${borderRadius}px` }}
        >
          <ImageIcon className="h-10 w-10" />
          <span className="text-sm">Sem imagem — configure a URL nas propriedades</span>
        </div>
      )}
      {caption && (
        <figcaption className="text-center text-xs text-muted-foreground mt-2 italic">
          {caption}
        </figcaption>
      )}
    </figure>
  );
}

ImageBlock.craft = {
  displayName: 'Imagem',
  props: {
    src: '',
    alt: '',
    caption: '',
    objectFit: 'cover' as const,
    borderRadius: 0,
    mediaId: '',
  },
  rules: { canDrag: () => true },
};
